// Custom Calendar Implementation
class CustomCalendar {
  constructor(input) {
    this.input = input;
    this.isOpen = false;
    this.currentDate = new Date();
    this.selectedStartDate = null;
    this.selectedEndDate = null;
    this.isSelectingRange = false;

    this.monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    this.fullMonthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    this.showingDropdowns = {
      month1: false,
      year1: false,
      month2: false,
      year2: false,
    };

    this.init();
  }

  init() {
    this.createCalendar();
    this.bindEvents();
  }

  createCalendar() {
    // Create calendar container
    this.calendar = document.createElement("div");
    this.calendar.className = "custom-calendar";
    this.calendar.style.display = "none";

    // Position relative to input
    this.input.parentNode.style.position = "relative";
    this.input.parentNode.appendChild(this.calendar);

    this.render();
  }

  render() {
    const previousMonth = new Date(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth() - 1,
      1
    );
    const currentMonth = new Date(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth(),
      1
    );

    this.calendar.innerHTML = `
      <div class="calendar-container">
        <div class="calendar-months">
          <div class="calendar-month">
            <div class="calendar-header">
              <button type="button" class="nav-btn corner-prev-btn" data-action="corner-prev1">
                <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 1L2 6.5L8 12" stroke="#015F02" stroke-width="2"/>
                </svg>
              </button>
              <button type="button" class="nav-btn inner-prev-btn" data-action="inner-prev1">
                <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M-2.62268e-07 5.5L5.25 0.303846L5.25 10.6962L-2.62268e-07 5.5Z" fill="#015F02"/>
                </svg>
              </button>
              <div class="month-year-selector">
                <div class="month-selector" data-calendar="1">
                  <span class="month-display">${
                    this.monthNames[previousMonth.getMonth()]
                  }</span>
                  <div class="month-dropdown ${
                    this.showingDropdowns.month1 ? "show" : ""
                  }">
                    ${this.generateMonthOptions(previousMonth.getMonth(), 1)}
                  </div>
                </div>
                <div class="year-selector" data-calendar="1">
                  <span class="year-display">${previousMonth.getFullYear()}</span>
                  <div class="year-dropdown ${
                    this.showingDropdowns.year1 ? "show" : ""
                  }">
                    ${this.generateYearOptions(previousMonth.getFullYear(), 1)}
                  </div>
                </div>
              </div>
              <button type="button" class="nav-btn inner-next-btn" data-action="inner-next1">
                <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 5.5L0.750001 10.6962L0.750001 0.303848L6 5.5Z" fill="#015F02"/>
                </svg>
              </button>
              <button type="button" class="nav-btn corner-next-btn" data-action="corner-next1">
                <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 12L7 6.5L0.999997 0.999999" stroke="#015F02" stroke-width="2"/>
                </svg>
              </button>
            </div>
            <div class="calendar-grid">
              <div class="weekdays">
                <div class="weekday">Sun</div>
                <div class="weekday">Mon</div>
                <div class="weekday">Tue</div>
                <div class="weekday">Wed</div>
                <div class="weekday">Thu</div>
                <div class="weekday">Fri</div>
                <div class="weekday">Sat</div>
              </div>
              <div class="days">
                ${this.getMonthHTML(previousMonth)}
              </div>
            </div>
          </div>
          <div class="calendar-month">
            <div class="calendar-header">
              <button type="button" class="nav-btn corner-prev-btn" data-action="corner-prev2">
                <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 1L2 6.5L8 12" stroke="#015F02" stroke-width="2"/>
                </svg>
              </button>
              <button type="button" class="nav-btn inner-prev-btn" data-action="inner-prev2">
                <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M-2.62268e-07 5.5L5.25 0.303846L5.25 10.6962L-2.62268e-07 5.5Z" fill="#015F02"/>
                </svg>
              </button>
              <div class="month-year-selector">
                <div class="month-selector" data-calendar="2">
                  <span class="month-display">${
                    this.monthNames[currentMonth.getMonth()]
                  }</span>
                  <div class="month-dropdown ${
                    this.showingDropdowns.month2 ? "show" : ""
                  }">
                    ${this.generateMonthOptions(currentMonth.getMonth(), 2)}
                  </div>
                </div>
                <div class="year-selector" data-calendar="2">
                  <span class="year-display">${currentMonth.getFullYear()}</span>
                  <div class="year-dropdown ${
                    this.showingDropdowns.year2 ? "show" : ""
                  }">
                    ${this.generateYearOptions(currentMonth.getFullYear(), 2)}
                  </div>
                </div>
              </div>
              <button type="button" class="nav-btn inner-next-btn" data-action="inner-next2">
                <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 5.5L0.750001 10.6962L0.750001 0.303848L6 5.5Z" fill="#015F02"/>
                </svg>
              </button>
              <button type="button" class="nav-btn corner-next-btn" data-action="corner-next2">
                <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 12L7 6.5L0.999997 0.999999" stroke="#015F02" stroke-width="2"/>
                </svg>
              </button>
            </div>
            <div class="calendar-grid">
              <div class="weekdays">
                <div class="weekday">Sun</div>
                <div class="weekday">Mon</div>
                <div class="weekday">Tue</div>
                <div class="weekday">Wed</div>
                <div class="weekday">Thu</div>
                <div class="weekday">Fri</div>
                <div class="weekday">Sat</div>
              </div>
              <div class="days">
                ${this.getMonthHTML(currentMonth)}
              </div>
            </div>
          </div>
        </div>
        <div class="calendar-buttons">
          <button type="button" class="calendar-btn clear-btn" ${
            !this.selectedStartDate ? "disabled" : ""
          }>CLEAR</button>
          <button type="button" class="calendar-btn apply-btn" ${
            !this.isSelectionComplete() ? "disabled" : ""
          }>APPLY</button>
        </div>
      </div>
    `;
  }

  getMonthHTML(date) {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const startingDayOfWeek = firstDay.getDay();
    const daysInMonth = lastDay.getDate();

    let html = "";

    // Add empty cells for days before the first day of the month
    for (let i = 0; i < startingDayOfWeek; i++) {
      html += '<div class="calendar-day empty"></div>';
    }

    // Add days of the month
    for (let day = 1; day <= daysInMonth; day++) {
      const cellDate = new Date(year, month, day);
      const isSelected = this.isDateSelected(cellDate);
      const isInRange = this.isDateInRange(cellDate);
      const isHoverRange = this.isDateInHoverRange(cellDate);
      const isToday = this.isToday(cellDate);
      const isFutureDate = this.isFutureDate(cellDate);

      const classes = ["calendar-day"];
      if (isFutureDate) {
        classes.push("disabled");
      } else {
        if (isSelected) classes.push("selected");
        if (isInRange) classes.push("in-range");
        if (isHoverRange) classes.push("hover-range");
      }
      if (isToday) classes.push("today");

      html += `<div class="${classes.join(
        " "
      )}" data-date="${year}-${month}-${day}">${day}</div>`;
    }

    return html;
  }

  bindEvents() {
    // Input click to open calendar
    this.input.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation(); // Prevent event bubbling
      this.toggle();
    });

    // Calendar event delegation
    this.calendar.addEventListener("click", (e) => {
      e.stopPropagation(); // Prevent event bubbling to document
      const target = e.target;

      if (
        target.classList.contains("calendar-day") &&
        !target.classList.contains("empty") &&
        !target.classList.contains("disabled")
      ) {
        e.preventDefault();
        const [year, month, day] = target.dataset.date.split("-").map(Number);
        const selectedDate = new Date(year, month, day);

        // Ensure we clear hover state before selecting
        if (this.hoverDate) {
          this.hoverDate = null;
        }

        this.selectDate(selectedDate);
      }

      if (target.classList.contains("nav-btn") || target.closest(".nav-btn")) {
        const navBtn = target.classList.contains("nav-btn")
          ? target
          : target.closest(".nav-btn");
        const action = navBtn.dataset.action;
        if (action) {
          this.navigate(action);
        }
      }

      if (target.classList.contains("clear-btn") && !target.disabled) {
        this.clear();
      }

      if (target.classList.contains("apply-btn") && !target.disabled) {
        this.apply();
      }

      // Handle month/year selector clicks
      if (target.classList.contains("month-display")) {
        const calendar = target.closest(".month-selector").dataset.calendar;
        this.toggleMonthDropdown(calendar);
      }

      if (target.classList.contains("year-display")) {
        const calendar = target.closest(".year-selector").dataset.calendar;
        this.toggleYearDropdown(calendar);
      }

      // Handle month/year selection
      if (target.classList.contains("dropdown-item")) {
        const calendar = target.dataset.calendar;
        const month = target.dataset.month;
        const year = target.dataset.year;

        if (month !== undefined) {
          this.selectMonth(parseInt(month), parseInt(calendar));
        }

        if (year !== undefined) {
          this.selectYear(parseInt(year), parseInt(calendar));
        }
      }
    });

    // Add mouse events for hover range preview
    this.calendar.addEventListener("mouseover", (e) => {
      const target = e.target;
      if (
        target.classList.contains("calendar-day") &&
        !target.classList.contains("empty") &&
        !target.classList.contains("disabled")
      ) {
        if (this.selectedStartDate && !this.selectedEndDate) {
          const [year, month, day] = target.dataset.date.split("-").map(Number);
          const newHoverDate = new Date(year, month, day);

          // Only update if hover date actually changed to prevent unnecessary re-renders
          if (
            !this.hoverDate ||
            this.hoverDate.getTime() !== newHoverDate.getTime()
          ) {
            this.hoverDate = newHoverDate;
            this.render();
          }
        }
      }
    });

    this.calendar.addEventListener("mouseleave", (e) => {
      // Only clear hover when actually leaving the calendar container
      if (!this.calendar.contains(e.relatedTarget)) {
        if (this.selectedStartDate && !this.selectedEndDate && this.hoverDate) {
          this.hoverDate = null;
          this.render();
        }
      }
    });

    // Close on outside click (excluding input field and calendar)
    document.addEventListener("click", (e) => {
      if (this.isOpen) {
        // Check if click is outside both calendar and input wrapper
        const isClickInsideCalendar = this.calendar.contains(e.target);
        const isClickOnInput = e.target === this.input;
        const isClickOnInputWrapper = this.input.parentNode.contains(e.target);

        // Check if any dropdown is open and close them on outside click
        const hasOpenDropdowns = Object.values(this.showingDropdowns).some(
          (isOpen) => isOpen
        );
        if (
          hasOpenDropdowns &&
          !isClickInsideCalendar &&
          !isClickOnInput &&
          !isClickOnInputWrapper
        ) {
          // Close all dropdowns
          this.showingDropdowns = {
            month1: false,
            year1: false,
            month2: false,
            year2: false,
          };
          this.render();
          return;
        }

        // Only close calendar if click is truly outside
        if (
          !isClickInsideCalendar &&
          !isClickOnInput &&
          !isClickOnInputWrapper
        ) {
          this.close();
        }
      }
    });
  }

  selectDate(date) {
    if (
      !this.selectedStartDate ||
      (this.selectedStartDate && this.selectedEndDate)
    ) {
      // Start new selection
      this.selectedStartDate = new Date(date);
      this.selectedEndDate = null;
      this.hoverDate = null;
      this.isSelectingRange = true;
    } else if (this.selectedStartDate && !this.selectedEndDate) {
      // Complete range selection
      if (date < this.selectedStartDate) {
        this.selectedEndDate = new Date(this.selectedStartDate);
        this.selectedStartDate = new Date(date);
      } else {
        this.selectedEndDate = new Date(date);
      }
      this.hoverDate = null;
      this.isSelectingRange = false;
    }

    this.render();
    // Keep calendar open for further interaction

    // Enable Apply button when at least one date is selected
    this.updateApplyButton();
  }

  navigate(action) {
    // Create a new date object to avoid reference issues
    const newDate = new Date(this.currentDate);

    switch (action) {
      // Outer arrows - change year only
      case "corner-prev1":
      case "corner-prev2":
        newDate.setFullYear(newDate.getFullYear() - 1);
        break;
      case "corner-next1":
      case "corner-next2":
        newDate.setFullYear(newDate.getFullYear() + 1);
        break;

      // Inner arrows - change month only
      case "inner-prev1":
      case "inner-prev2":
        newDate.setMonth(newDate.getMonth() - 1);
        break;
      case "inner-next1":
      case "inner-next2":
        newDate.setMonth(newDate.getMonth() + 1);
        break;

      // Legacy navigation (if any old references remain)
      case "prev":
      case "prev2":
        newDate.setMonth(newDate.getMonth() - 1);
        break;
      case "next":
      case "next2":
        newDate.setMonth(newDate.getMonth() + 1);
        break;
    }

    // Update the current date with the new date
    this.currentDate = newDate;
    this.render();
    // Keep calendar open for navigation
  }

  isDateSelected(date) {
    if (!this.selectedStartDate) return false;

    const dateStr = this.formatDateStr(date);
    const startStr = this.formatDateStr(this.selectedStartDate);
    const endStr = this.selectedEndDate
      ? this.formatDateStr(this.selectedEndDate)
      : null;

    return dateStr === startStr || (endStr && dateStr === endStr);
  }

  isDateInRange(date) {
    if (!this.selectedStartDate || !this.selectedEndDate) return false;
    return date > this.selectedStartDate && date < this.selectedEndDate;
  }

  isDateInHoverRange(date) {
    if (!this.selectedStartDate || this.selectedEndDate || !this.hoverDate)
      return false;
    const startDate = this.selectedStartDate;
    const endDate = this.hoverDate;

    if (startDate < endDate) {
      return date > startDate && date < endDate;
    } else {
      return date > endDate && date < startDate;
    }
  }

  isToday(date) {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  }

  isFutureDate(date) {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to start of day
    const compareDate = new Date(date);
    compareDate.setHours(0, 0, 0, 0); // Reset time to start of day
    return compareDate > today;
  }

  formatDateStr(date) {
    return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
  }

  formatDate(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return `${
      months[date.getMonth()]
    } ${date.getDate()}, ${date.getFullYear()}`;
  }

  clear() {
    this.selectedStartDate = null;
    this.selectedEndDate = null;
    this.input.value = "";
    this.render();
    this.updateApplyButton();
    this.triggerChange();
  }

  apply() {
    if (this.selectedStartDate) {
      if (this.selectedEndDate) {
        // Check if start and end dates are the same
        if (
          this.selectedStartDate.getTime() === this.selectedEndDate.getTime()
        ) {
          this.input.value = this.formatDate(this.selectedStartDate);
        } else {
          this.input.value = `${this.formatDate(
            this.selectedStartDate
          )} - ${this.formatDate(this.selectedEndDate)}`;
        }
      } else {
        this.input.value = this.formatDate(this.selectedStartDate);
      }
    }
    this.close();
    this.triggerChange();
  }

  triggerChange() {
    const inputEvent = new Event("input", { bubbles: true });
    const changeEvent = new Event("change", { bubbles: true });
    this.input.dispatchEvent(inputEvent);
    this.input.dispatchEvent(changeEvent);
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    // Reset calendar state based on whether dates are selected
    this.resetToInitialState();
    this.calendar.style.display = "block";
    this.isOpen = true;
  }

  resetToInitialState() {
    // Close any open dropdowns
    this.showingDropdowns = {
      month1: false,
      year1: false,
      month2: false,
      year2: false,
    };

    // If dates are selected, show the calendar at the appropriate date range
    if (this.selectedStartDate) {
      if (this.selectedEndDate) {
        // If we have both start and end dates, show the end date's month on right
        // This ensures the range is visible across both calendars
        this.currentDate = new Date(
          this.selectedEndDate.getFullYear(),
          this.selectedEndDate.getMonth(),
          1
        );
      } else {
        // If only start date, show that month on the right
        this.currentDate = new Date(
          this.selectedStartDate.getFullYear(),
          this.selectedStartDate.getMonth(),
          1
        );
      }
    } else {
      // If no dates selected, reset to current date (today)
      this.currentDate = new Date();
    }

    // Re-render the calendar with the appropriate state
    this.render();
  }

  close() {
    this.calendar.style.display = "none";
    this.isOpen = false;
  }

  updateApplyButton() {
    const applyBtn = this.calendar.querySelector(".apply-btn");
    const clearBtn = this.calendar.querySelector(".clear-btn");

    if (applyBtn) {
      applyBtn.disabled = !this.isSelectionComplete();
    }

    if (clearBtn) {
      clearBtn.disabled = !this.selectedStartDate;
    }
  }

  isSelectionComplete() {
    // Selection is complete when:
    // 1. We have both start and end dates (range selection)
    // 2. OR we have only start date but isSelectingRange is false (single date confirmed)
    return (
      (this.selectedStartDate && this.selectedEndDate) ||
      (this.selectedStartDate && !this.isSelectingRange)
    );
  }

  generateMonthOptions(currentMonth, calendar) {
    let options = "";

    // Generate month options with current month highlighting
    for (let month = 0; month < this.fullMonthNames.length; month++) {
      const isCurrentMonth = month === currentMonth;
      options += `<div class="dropdown-item ${
        isCurrentMonth ? "current-month" : ""
      }" data-month="${month}" data-calendar="${calendar}">${
        this.fullMonthNames[month]
      }</div>`;
    }

    return options;
  }

  generateYearOptions(currentYear, calendar) {
    const startYear = Math.max(1901, currentYear - 20);
    const endYear = Math.min(2099, currentYear + 20);
    let options = "";

    // Generate years around current year for better UX
    for (let year = startYear; year <= endYear; year++) {
      const isCurrentYear = year === currentYear;
      options += `<div class="dropdown-item ${
        isCurrentYear ? "current-year" : ""
      }" data-year="${year}" data-calendar="${calendar}">${year}</div>`;
    }

    return options;
  }

  toggleMonthDropdown(calendar) {
    // Close all other dropdowns
    this.showingDropdowns = {
      month1: false,
      year1: false,
      month2: false,
      year2: false,
    };

    // Toggle the selected dropdown
    this.showingDropdowns[`month${calendar}`] = true;
    this.render();

    // Scroll to current month after render
    setTimeout(() => {
      const monthDropdown = this.calendar.querySelector(`.month-dropdown.show`);
      const currentMonthItem = monthDropdown?.querySelector(".current-month");
      if (currentMonthItem && monthDropdown) {
        currentMonthItem.scrollIntoView({
          block: "center",
          behavior: "smooth",
        });
      }
    }, 10);
  }

  toggleYearDropdown(calendar) {
    // Close all other dropdowns
    this.showingDropdowns = {
      month1: false,
      year1: false,
      month2: false,
      year2: false,
    };

    // Toggle the selected dropdown
    this.showingDropdowns[`year${calendar}`] = true;
    this.render();

    // Scroll to current year after render
    setTimeout(() => {
      const yearDropdown = this.calendar.querySelector(`.year-dropdown.show`);
      const currentYearItem = yearDropdown?.querySelector(".current-year");
      if (currentYearItem && yearDropdown) {
        currentYearItem.scrollIntoView({ block: "center", behavior: "smooth" });
      }
    }, 10);
  }

  selectMonth(month, calendar) {
    if (calendar === 1) {
      // For first calendar (previous month), adjust to show selected month as previous
      const newDate = new Date(this.currentDate);
      newDate.setMonth(month + 1);
      this.currentDate = newDate;
    } else {
      // For second calendar (current month), set to selected month
      this.currentDate.setMonth(month);
    }

    // Close dropdowns and re-render
    this.showingDropdowns = {
      month1: false,
      year1: false,
      month2: false,
      year2: false,
    };

    this.render();
  }

  selectYear(year, calendar) {
    if (calendar === 1) {
      // For first calendar (previous month), we need to adjust so the selected year shows as previous
      const currentMonth = this.currentDate.getMonth();
      if (currentMonth === 0) {
        // If current is January, set year+1 for December of previous year
        this.currentDate.setFullYear(year + 1);
      } else {
        this.currentDate.setFullYear(year);
      }
    } else {
      // For second calendar (current month), set to selected year
      this.currentDate.setFullYear(year);
    }

    // Close dropdowns and re-render
    this.showingDropdowns = {
      month1: false,
      year1: false,
      month2: false,
      year2: false,
    };

    this.render();
  }
}

// Initialize custom calendar
document.addEventListener("DOMContentLoaded", function () {
  const orderDateInput = document.getElementById("orderDate");
  if (orderDateInput) {
    const calendar = new CustomCalendar(orderDateInput);

    // Expose clear function globally for clear filters button
    window.clearOrderDateRange = function () {
      calendar.clear();
    };
  }
});
